var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconGood(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_good",
    transform: "translate(-139 -332)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_326",
    "data-name": "\\uD0C0\\uC6D0 326",
    cx: 23,
    cy: 23,
    r: 23,
    transform: "translate(139 332)",
    fill: "#4fa9ba",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_325",
    "data-name": "\\uD0C0\\uC6D0 325",
    cx: 16,
    cy: 16,
    r: 16,
    transform: "translate(146 339)",
    fill: "#4fa9ba"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uD0C0\\uC6D0_331",
    "data-name": "\\uD0C0\\uC6D0 331",
    transform: "translate(154 347)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7,
    fill: "none"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGood);
export default __webpack_public_path__ + "static/media/icon_good.f863205711d2585b5b8f904a95fe6d63.svg";
export { ForwardRef as ReactComponent };